import {signOut} from 'firebase/auth'
import {auth} from '../App'

export const signOutFromFirebase = async () => {
    return await signOut(auth)
}

export async function getCurrentUser() {
    await auth.currentUser
}